import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";

export function createTarget(k, position, index) {
    const token = k.add([
        k.sprite("cross_mark_o"),
        k.pos(position.x, position.y),
        k.anchor("center"),
        k.scale(3),
        k.opacity(0),
        k.z(40),
        ACTOR_TAGS.TARGET,
        { slotIndex: index }
    ]);

    // Token spawn animation
    token.spawn = (finalY, onComplete) => {
        k.tween(0, 1, 0.15, (v) => token.opacity = v, k.easings.linear);
        k.tween(token.scale.x, 1, 0.35, (v) => token.scale = k.vec2(v), k.easings.easeOutBounce);

        k.tween(
            token.pos.y,
            finalY,
            0.35,
            (v) => token.pos = k.vec2(token.pos.x, v),
            k.easings.easeOutBounce
        ).onEnd(() => {
            // DESIGN : TARGET TOKEN SPAWN

            if (onComplete) onComplete();
        });
    };

    // Token removal animation
    token.removeToken = () => {
        k.tween(token.opacity, 0, 0.2, (v) => token.opacity = v, k.easings.linear);

        k.tween(
            token.scale.x,
            0,
            0.2,
            (v) => token.scale = k.vec2(v),
            k.easings.easeInBack
        ).onEnd(() => {
            token.destroy();
        });
    };

    return token;
}